import setLocationGroups from './setLocationGroups';
import setLocationGroup from './setLocationGroup';
import resetCurrentLocationGroup from './resetCurrentLocationGroup';

export default {
  setLocationGroups,
  setLocationGroup,
  resetCurrentLocationGroup,
};
